<template>
  <div class='pc_course'>
    <div class='tab'>
      <el-menu
        :router='true'
        :default-active='this.$route.path'
        class='el-menu-demo'
        mode='horizontal'
        @select='handleSelect'
        background-color='#545c64'
        text-color='#fff'
        active-text-color='#ffd04b'
      >
        <el-menu-item  index='/home/pc/course/plans'>课件教案管理</el-menu-item>
        <el-submenu index='/home/pc/course/category'>
          <template slot='title'>类目管理</template>
          <el-menu-item index='/home/pc/course/category/one'>一级类目</el-menu-item>
          <el-menu-item index='/home/pc/course/category/two'>二级类目</el-menu-item>
        </el-submenu>
        <el-menu-item index='/home/pc/course/gifs'>课程介绍Gif图管理</el-menu-item>

      </el-menu>
    </div>

    <div class='pc_main'>
      <!-- 子路由渲染处 -->
      <router-view></router-view>
    </div>
  </div>
</template>



<script>
export default {
  name: 'pc_course',
  data() {
    return {
      activeIndex: '/home/pc/course/plans'
    };
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key;
    }
  }
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
/* .pc_index {
  margin-left: -20px;
} */
.tab {
  width: 100%;
}
.pc_main {
  margin-top: 10px;
  height: 100%;
}
</style>